import { cn } from '@/lib/utils';

/**
 * A talent's video introduction, played from the short-lived signed URL the API mints
 * for the console. The audit queue, the review screen and the talent detail all show it
 * the same way: native controls, only the metadata fetched until the admin presses play
 * (the queue can hold several), and inline on a phone rather than full screen.
 */
export function VideoPlayer({
  src,
  label,
  className,
}: {
  src: string;
  /** The accessible name — whose video it is. */
  label: string;
  className?: string;
}) {
  return (
    <video
      src={src}
      controls
      preload="metadata"
      playsInline
      aria-label={label}
      className={cn('max-w-full rounded-lg bg-navy', className)}
    />
  );
}
